import apiUrl from "../../../utils/settings";


export const getHomepageDataUrl = () => {
    return apiUrl + '/home';
}